// const { VITE_APP_DEFAULT_AUTH, VITE_BASE_URL } = import.meta.env;

// const appConfigs = {
//   auth: VITE_APP_DEFAULT_AUTH,
//   baseUrl: VITE_BASE_URL,
//   googleMapAPIKey: "AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE"
// };
const {
  VITE_APP_DEFAULT_AUTH,
  VITE_BASE_URL,
  VITE_AUTH_APP_URL,
  VITE_AUTH_API_URL,
  VITE_AUTH_CLIENT_ID,
  VITE_EDIT_PROFILE,
  SENTRY_DSN,
} = import.meta.env;

const appConfigs = {
  auth: VITE_APP_DEFAULT_AUTH,
  authAppUrl: VITE_AUTH_APP_URL,
  authApiUrl: VITE_AUTH_API_URL,
  baseUrl: VITE_BASE_URL,
  client_id: VITE_AUTH_CLIENT_ID,
  edit_profile: VITE_EDIT_PROFILE,
  sentry_dns: SENTRY_DSN
};
export default appConfigs;
